<div class="new-campaign-wrapper">
    <div class="campaign-container">
        <!-- Form Section - Centered -->
        <div class="form-section">
            <div class="form-card">
                <!-- Lead Form -->
                <div class="card-body" *ngIf="isLeadFormVisible">
                    <h2 class="form-title">Bajaj Capital Property Advisory</h2>
                    <p class="form-subtitle">Fill in your details below to connect with our Property Advisor.</p>

                    <form #leadForm="ngForm" (ngSubmit)="PostData(leadForm)">
                        <div class="form-group">
                            <label for="name">Name</label>
                            <input type="text" autocomplete="off" id="name" name="name" [(ngModel)]="name"
                                class="form-control" (blur)="removeErrorMsg('name')" placeholder="Enter your full name"
                                maxlength="40" inputmode="text"
                                oninput="this.value = this.value.replace(/[^a-zA-Z\s]/g, '').replace(/\s{2,}/g, ' ');"
                                (keydown)="alphaOnly($event)">
                            <div class="errormsg" *ngIf="nameValidateMessage == 'lengthError'">
                                Invalid full name
                            </div>
                            <div class="errormsg" *ngIf="nameValidateMessage == 'required'">
                                Full name is mandatory
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="mobile">Mobile Number</label>
                            <input type="text" (keydown.space)="$event.preventDefault();" autocomplete="off" id="mobile"
                                name="mobile" [(ngModel)]="mobile" class="form-control"
                                placeholder="Enter your mobile number" minlength="10" maxlength="10"
                                pattern="[6789][0-9]{9}" (blur)="removeErrorMsg('mobile')" inputmode="numeric"
                                oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                                (keypress)="numbersOnly($event)">
                            <div class="errormsg" *ngIf="mobileValidateMessage == 'lengthError'">
                                10 digit mobile number is mandatory
                            </div>
                            <div class="errormsg" *ngIf="mobileValidateMessage == 'invalid'">
                                Invalid mobile number
                            </div>
                            <div class="errormsg" *ngIf="mobileValidateMessage == 'required'">
                                Mobile number is mandatory
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="email">Email Address</label>
                            <input type="text" autocomplete="off" (keydown.space)="$event.preventDefault();" id="email"
                                name="email" [(ngModel)]="email" class="form-control"
                                placeholder="Enter your email address" maxlength="50" (blur)="removeErrorMsg('email')">
                            <div class="errormsg" *ngIf="emailValidateMessage == 'invalid'">
                                Invalid email address
                            </div>
                            <div class="errormsg" *ngIf="emailValidateMessage == 'required'">
                                Email address is mandatory
                            </div>
                        </div>

                        <div class="text-center">
                            <button type="submit" class="btn btn-primary submit-btn"
                                (click)="checkValidationMsg(leadForm)">Connect with an Expert</button>
                        </div>
                    </form>

                    <p class="security-note">Your information is secure and will only be used to assist you.</p>
                </div>

                <!-- OTP Form -->
                <div class="card-body otp-card" *ngIf="isOtpFormVisible">
                    <div id="main_loader" style="display:none;">
                        <div class="loader-wrapper">
                            <div class="lds-roller">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                    </div>
                    <h2 class="form-title">Verify Your Number</h2>
                    <form #otpForm="ngForm" (ngSubmit)="SubmitOTP(otpForm)">
                        <p><a href="javascript:void(0)" id="btn-back" (click)="changeNumber()"><i
                                    class="fa fa-chevron-left"></i> Change Number</a></p>
                        <div class="alert alert-success">
                            <i class="fa fa-check"></i>
                            <span>OTP successfully sent on number {{displayMobile}}</span>
                        </div>
                        <div class="form-group">
                            <input type="text" autocomplete="off" (keydown.space)="$event.preventDefault();"
                                (keyup)="removeErrorMsg('otp')" id="otp" name="otp" [(ngModel)]="userOTP"
                                class="form-control" maxlength="6" placeholder="Enter OTP"
                                (keypress)="numbersOnlyotp($event)">
                            <div class="errormsg" *ngIf='!otpVerifiedStatus'>
                                Invalid OTP
                            </div>
                            <div class="errormsg" *ngIf="otpValidateMessage == 'required'">
                                Please enter OTP to continue.
                            </div>
                            <div class="errormsg" *ngIf="otpValidateMessage == 'lengthError'">Invalid OTP
                            </div>
                        </div>
                        <div class="text-center">
                            <button type="submit" class="btn btn-primary submit-btn" id="otp_verify_btn">Submit</button>
                        </div>
                        <div class="form-group text-center otp-timer">
                            <span *ngIf="isTimer">Didn't receive OTP? Resend in <strong>{{timeleft}}</strong>
                                seconds</span>
                            <a class="resendotp" href="javascript:void(0)" *ngIf="isResend" (click)="resendOTP()">Resend
                                OTP</a>
                        </div>
                    </form>
                </div>

                <!-- Thank You -->
                <div class="card-body success-card" *ngIf="isThanksVisible">
                    <div class="success-tick">
                        <h2>Thank You!</h2>
                    </div>
                    <h6>Our Property Advisor will get in touch with you shortly.</h6>
                </div>
            </div>
        </div>

        <!-- Headline Section - Below Form -->
        <div class="headline-section">
            <p class="exclusive-text">An Exclusive Opportunity for</p>
            <h1 class="main-headline">BAJAJ CAPITAL CLIENTS</h1>
        </div>
    </div>
</div>
